import { render, staticRenderFns } from "./KMonetary.vue?vue&type=template&id=2783e1c8&scoped=true&"
import script from "./KMonetary.vue?vue&type=script&lang=js&"
export * from "./KMonetary.vue?vue&type=script&lang=js&"
import style0 from "./KMonetary.vue?vue&type=style&index=0&id=2783e1c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783e1c8",
  null
  
)

export default component.exports